import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';

const StyledContainer = styled(FullWidthListContainer)`
    flex-direction: row;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }

    > * {
        flex: 1;
    }
`;
/**
 * Враппер для двух компонентов формы, размещает компоненты в строку, на мобилке в столбец
 * компоненты должны иметь свойство "flex: 1"
 */
export const TwoFieldWrapper = ({ children }: { children: [JSX.Element, JSX.Element] }): JSX.Element => {
    return (
        <StyledContainer $size={12}>
            {children}
        </StyledContainer>
    );
};
